import type { WebSocketHookReturn } from '../hooks/useWebSocket'
import { BookCard } from '../components/BookCard'
import { ConvictionStrip } from '../components/ConvictionStrip'
import { FleetValueOverlay } from '../components/FleetValueOverlay'
import { IncubationRosterPanel } from '../components/IncubationRosterPanel'
import { LifecycleFunnel } from '../components/LifecycleFunnel'
import { PicksPanel } from '../components/PicksPanel'
import { RecentExecutions } from '../components/RecentExecutions'
import { WorkflowRunsFeed } from '../components/WorkflowRunsFeed'
import { useBooks } from '../hooks/useBooks'
import '../components/Dashboard.css'
import './FleetPage.css'

/**
 * Phone Fleet view (the pre-desk page body, unchanged), picks-first (spec
 * §3): Zone 1 answers "are my picks working?", Zone 2 shows the incubation
 * pipeline, Zone 3 the fleet of books, Zone 4 today's activity. Ops feeds
 * live on /ops.
 */
export function FleetLegacyBody({ ws }: { ws: WebSocketHookReturn }) {
  const { byRole, books, isLoading: booksPending, isError: booksError } = useBooks()
  const research = byRole('research')

  return (
    <main className="dashboard-content fleet-page">
      <section className="dash-zone">
        <h2 className="dash-zone-title">Picks</h2>
        <PicksPanel book={research} booksPending={booksPending} booksError={booksError} />
      </section>

      <section className="dash-zone">
        <h2 className="dash-zone-title">Incubation pipeline</h2>
        <div className="dash-zone-grid dash-zone-grid--2">
          <ConvictionStrip />
          {research ? <LifecycleFunnel accountId={research.id} /> : null}
        </div>
        {research ? (
          <div className="dash-zone-grid">
            <IncubationRosterPanel accountId={research.id} />
          </div>
        ) : null}
      </section>

      <section className="dash-zone">
        <h2 className="dash-zone-title">Books</h2>
        <div className="fleet-cards-row">
          <BookCard book={byRole('research')} role="research" />
          <BookCard book={byRole('validation')} role="validation" />
          <BookCard book={byRole('live')} role="live" />
        </div>
        <FleetValueOverlay books={books} />
      </section>

      <section className="dash-zone">
        <h2 className="dash-zone-title">Today's activity</h2>
        <p className="fleet-zone-caption caption">
          research book (default) — broker-backed, not per-book
        </p>
        <div className="dash-zone-grid dash-zone-grid--2">
          <RecentExecutions ws={ws} />
          <WorkflowRunsFeed />
        </div>
      </section>
    </main>
  )
}
